<!--suppress ALL -->
<template>
    <hr v-if="separator" class="dropdown-divider">
    <a
            v-else-if="!custom && !hasLink"
            class="dropdown-item"
            :class="anchorClasses"
            @click="selectItem">
        <slot/>
    </a>
    <div
            v-else
            :class="itemClasses"
            @click="selectItem">
        <slot/>
    </div>
</template>

<script lang="ts">
	import {Component, Vue, Prop} from 'annotation';

	@Component
	export default class GDropdownItem extends Vue {

		@Prop({default: null})
		public value: any;

		@Prop({type: Boolean, default: false})
		public separator: boolean;

		@Prop({type: Boolean, default: false})
		public disabled: boolean;

		@Prop({type: Boolean, default: false})
		public custom: boolean;

		@Prop({type: Boolean, default: false})
		public paddingless: boolean;

		@Prop({type: Boolean, default: false})
		public hasLink: boolean

		public get anchorClasses() {
			return {
				'is-disabled': this.$parent.disabled || this.disabled,
				'is-paddingless': this.paddingless,
				'is-active': this.value !== null && this.value === this.$parent.selected
			}
		}

		public get itemClasses() {
			return {
				'dropdown-item': !this.hasLink,
				'is-disabled': this.disabled,
				'is-paddingless': this.paddingless,
				'is-active': this.value !== null && this.value === this.$parent.selected,
				'has-link': this.hasLink
			}
		}

		/**
		 * Check if item can be clickable.
		 */
		public get isClickable() {
			return !this.$parent.disabled && !this.separator && !this.disabled && !this.custom
		}

		public selectItem() {
			if (!this.isClickable) return

			this.$parent.selectItem(this.value)
			this.$emit('click')
		}

		public created() {
			if (!this.$parent.$data._isDropdown) {
				this.$destroy()
				throw new Error('You should wrap bDropdownItem on a bDropdown')
			}
		}
	}
</script>
